<template>
  <el-table-column
    prop="customerGroups"
    label="Vevőcsoport"
    show-overflow-tooltip
    min-width="180"
  >
    <template slot-scope="scope">
      <el-tag size="small" type="info" v-if="!scope.row.is_customer">Nem vevő</el-tag>
      <div v-if="scope.row.is_customer" style="display: inline-block;">
        <el-tag size="small" type="danger" v-if="scope.row.customer_groups.length === 0">Nincs vevőcsoport</el-tag>
        <el-tooltip placement="top" style="max-width: 300px;" v-if="scope.row.customer_groups.length > 0">
          <div slot="content">
            {{ scope.row.customer_groups.map(p => p.name).join(', ') }}
          </div>
          <el-tag size="small" type="primary">{{ scope.row.customer_groups.length }} vevőcsoport</el-tag>
        </el-tooltip>
      </div>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'customerGroups',
};
</script>
